import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

function AssignmentCards({ item, index }) {
	const [feed, setFeed] = useState(null);
	let menuRef = useRef();
	
	useEffect(() => {
		let handler = (e) => {
			if (!menuRef.current.contains(e.target)) {
				setFeed(null);
			}
		};
		document.addEventListener('mousedown', handler);
		return () => {
			document.removeEventListener('mousedown', handler);
		}
	}, []);

	return (
		<Container>
			<Card>
				<CardTop>
					<Left>
						<SlNo>{index}.</SlNo>
						<Question>{item?.title.replace("(Closed)", '')}</Question>
					</Left>
					<Right ref={menuRef}>
						{item.assignment_type === "entire_qstn" ? (
							<>
								{/* Show individual questions for grade-based */}
								{item.questions_mark?.map((question) => (
									<ScoreCard key={question.question_no}>
										<QuestionNo>
											Question {question.question_no}
										</QuestionNo>
										<Scrore>
											Mark: {question.mark}
										</Scrore>
										<FeedbackWrapper>
											{question.feedback ? (
												<>
													<Feedback 
														className="click"
														onClick={() => setFeed(feed === `q-${question.question_no}` ? null : `q-${question.question_no}`)}>
														Feedback
													</Feedback>
													<PopupArrow 
														src={require("../../../assets/images/popuparrow.svg").default}
														className={feed === `q-${question.question_no}` ? "popup" : ""}
													/>
													<Popup className={feed === `q-${question.question_no}` ? "popup" : ""}>
														<Heading>Feedback</Heading>
														<Content>
															{question.feedback}
														</Content>
													</Popup>
												</>
											) : (
												<Feedback className="disabled">No Feedback</Feedback>
											)}
										</FeedbackWrapper>
									</ScoreCard>
								))}
								
								{/* Total Result Card */}
								<ScoreCard className="total">
									<QuestionNo className="total">Total Result</QuestionNo>
									<Scrore className="total">
										{item.mark} / {item.total_mark}
									</Scrore>
								</ScoreCard>
							</>
						) : (
							<>
								{/* For qstn_wise - only show Total Result and Overall Feedback */}
								<ScoreCard className="total">
									<QuestionNo className="total">Total Result</QuestionNo>
									<Scrore className="total">
										{item.assignment_pass_fail_status?.toUpperCase()}
									</Scrore>
								</ScoreCard>
								
								{/* Overall Feedback Card */}
								<ScoreCard className="feedback-card">
									<QuestionNo className="feedback-title">Overall Feedback</QuestionNo>
									<FeedbackWrapper>
										{item.feedback ? (
											<>
												<Feedback 
													className="click"
													onClick={() => setFeed(feed === 'total' ? null : 'total')}>
													View Feedback
												</Feedback>
												<PopupArrow 
													src={require("../../../assets/images/popuparrow.svg").default}
													className={feed === 'total' ? "popup" : ""}
												/>
												<Popup className={feed === 'total' ? "popup" : ""}>
													<Heading>Overall Feedback</Heading>
													<Content>
														{item.feedback}
													</Content>
												</Popup>
											</>
										) : (
											<Feedback className="disabled">No Feedback</Feedback>
										)}
									</FeedbackWrapper>
								</ScoreCard>
							</>
						)}
					</Right>
				</CardTop>
				{item.submitted_file && (
					<CardBottom>
						<ViewSubmission
							onClick={() => {
								window.open(item.submitted_file);
							}}
						>
							View Submission
						</ViewSubmission>
					</CardBottom>
				)}
			</Card>
		</Container>
	);
}

export default AssignmentCards;

const Container = styled.div``;
const Card = styled.div`
	padding: 12px;
	border: 1px solid #e7e7e7;
	border-radius: 16px;
	margin-bottom: 10px;
	transition: all 0.3s ease;
	
	&:hover {
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
	}
`;
const CardTop = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 5px;
`;
const Left = styled.div`
	width: 40%;
	display: flex;
	align-items: flex-start;
`;
const SlNo = styled.h2`
	color: #010101;
	font-size: 16px;
	margin-right: 10px;
	font-weight: 600;
`;
const Question = styled.h4`
	color: #010101;
	font-size: 16px;
	width: 90%;
	font-weight: 500;
	line-height: 1.4;
`;

const Right = styled.div`
	width: 60%;
	gap: 10px;
	display: flex;
	align-items: stretch;
	justify-content: flex-end;
`;
const ScoreCard = styled.div`
	position: relative;
	border: 1px solid #e7e7e7;
	border-radius: 16px;
	padding: 12px;
	width: 145px;
	min-height: 120px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	background: #ffffff;
	transition: all 0.3s ease;
	
	&:hover {
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	}
	
	&.total {
		background: linear-gradient(135deg, #917AFD 0%, #7461E3 100%);
		border: none;
		color: white;
	}
	
	&.feedback-card {
		background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
		border: none;
		color: white;
	}
`;
const QuestionNo = styled.h4`
	color: #9d9d9d;
	font-size: 13px;
	text-align: center;
	margin-bottom: 8px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	
	&.total {
		color: #ffffff;
		font-size: 14px;
	}
	
	&.feedback-title {
		color: #ffffff;
		font-size: 13px;
	}
`;
const Scrore = styled.h4`
	color: #010101;
	text-align: center;
	font-size: 16px;
	margin-bottom: 8px;
	font-weight: 600;
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	
	&.total {
		color: #ffffff;
		font-size: 20px;
		font-weight: 700;
	}
`;

const FeedbackWrapper = styled.div`
	margin-top: auto;
`;

const Feedback = styled.div`
	color: #917AFD;
	background: #EDF5FE;
	border-radius: 6px;
	padding: 6px 8px;
	font-size: 13px;
	text-align: center;
	font-family: 'inter-light';
	font-weight: 500;
	transition: all 0.2s ease;
	
	&.click {
		background: rgba(255, 255, 255, 0.9);
		color: #4CAF50;
		cursor: pointer;
		
		&:hover {
			background: #ffffff;
			box-shadow: 0 2px 6px rgba(76, 175, 80, 0.3);
		}
		
		&:active {
			transform: translateY(0);
		}
	}
	
	&.disabled {
		background: rgba(255, 255, 255, 0.3);
		color: rgba(255, 255, 255, 0.7);
		cursor: not-allowed;
		opacity: 0.7;
	}
`;
const PopupArrow = styled.img`
	display: none;
	&.popup {
		width: 25px;
		position: absolute;
		bottom: -14.5px;
		left: 50%;
		transform: translateX(-50%);
		display: block;
		z-index: 101;
		filter: drop-shadow(0 -2px 4px rgba(0, 0, 0, 0.1));
	}
`;
const Popup = styled.div`
	display: none;
	&.popup {
		position: absolute;
		top: calc(100% + 15px);
		left: 50%;
		transform: translateX(-50%);
		width: 280px;
		display: block;
		border: 1px solid #4CAF50;
		padding: 16px;
		border-radius: 12px;
		z-index: 100;
		background: #ffffff;
		box-shadow: 0px 8px 24px rgba(76, 175, 80, 0.2);
		
		@media all and (max-width: 768px) {
			left: auto;
			right: 0;
			transform: none;
		}
	}
`;
const Heading = styled.h4`
	color: #4CAF50;
	font-size: 16px;
	margin-bottom: 12px;
	font-family: "inter-semibold";
	font-weight: 600;
	border-bottom: 2px solid #E8F5E9;
	padding-bottom: 8px;
`;
const Content = styled.p`
	color: #404040;
	font-size: 14px;
	font-family: "inter-light";
	line-height: 1.6;
	word-break: break-word;
	max-height: 200px;
	overflow-y: auto;
	
	&::-webkit-scrollbar {
		width: 6px;
	}
	
	&::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 3px;
	}
	
	&::-webkit-scrollbar-thumb {
		background: #4CAF50;
		border-radius: 3px;
	}
	
	&::-webkit-scrollbar-thumb:hover {
		background: #45a049;
	}
`;
const CardBottom = styled.div`
	margin-left: 15px;
	margin-top: 8px;
`;
const ViewSubmission = styled.div`
	color: #917afd;
	background: #edf5fe;
	border-radius: 6px;
	width: max-content;
	padding: 6px 16px;
	font-size: 14px;
	cursor: pointer;
	font-weight: 500;
	transition: all 0.2s ease;
	
	&:hover {
		background: #917afd;
		color: #ffffff;
		box-shadow: 0 2px 6px rgba(145, 122, 253, 0.3);
	}
	
	&:active {
		transform: translateY(0);
	}
`;